const variationDropdownInstances = new WeakMap()

class VariationDropdown {
    constructor(dropdownElement) {
        /* HTML Elements */
        this.dropdownElement = dropdownElement
        this.buttonElement = this.dropdownElement.querySelector('.variation-dropdown-button')
        this.menuElement = this.dropdownElement.querySelector('.variation-dropdown-menu')

        /* State */
        this.open = false

        /* Event Handlers */
        this.buttonClickEventHandler = (event) => this.handleButtonClickEvent(event)
        this.menuClickEventHandler = () => this.close()
        this.documentClickEventHandler = (event) => this.handleDocumentClickEvent(event)
        this.resizeEventHandler = () => this.handleResizeEvent()
    }

    init() {
        if (!this.buttonElement || !this.menuElement) {
            return
        }

        this.buttonElement.addEventListener('click', this.buttonClickEventHandler)
        this.menuElement.addEventListener('click', this.menuClickEventHandler)
        document.addEventListener('click', this.documentClickEventHandler)
        window.addEventListener('resize', this.resizeEventHandler)
    }

    handleButtonClickEvent(event) {
        event.stopPropagation()
        this.open = this.dropdownElement.classList.toggle('active')

        if (this.open) {
            this.updateDropdownDirection()
        }
    }

    handleDocumentClickEvent(event) {
        if (this.open && !this.dropdownElement.contains(event.target)) {
            this.close()
        }
    }

    handleResizeEvent() {
        if (this.open) {
            this.updateDropdownDirection()
        }
    }

    updateDropdownDirection() {
        if (!this.buttonElement || !this.menuElement) {
            return
        }

        const previousDisplay = this.menuElement.style.display
        const previousVisibility = this.menuElement.style.visibility

        this.menuElement.style.visibility = 'hidden'
        this.menuElement.style.display = 'flex'

        const menuHeight = this.menuElement.offsetHeight
        const buttonRect = this.buttonElement.getBoundingClientRect()
        const spaceBelow = window.innerHeight - buttonRect.bottom
        const spaceAbove = buttonRect.top
        const opensUp = spaceBelow < menuHeight && spaceAbove > spaceBelow

        this.menuElement.style.display = previousDisplay
        this.menuElement.style.visibility = previousVisibility

        this.dropdownElement.classList.toggle('opens-up', opensUp)
        this.dropdownElement.classList.toggle('opens-down', !opensUp)
    }

    close() {
        this.dropdownElement.classList.remove('active')
        this.open = false
    }

    destroy() {
        if (this.buttonElement) {
            this.buttonElement.removeEventListener('click', this.buttonClickEventHandler)
        }
        if (this.menuElement) {
            this.menuElement.removeEventListener('click', this.menuClickEventHandler)
        }
        document.removeEventListener('click', this.documentClickEventHandler)
        window.removeEventListener('resize', this.resizeEventHandler)
        this.open = false
        variationDropdownInstances.delete(this.dropdownElement)
    }
}

export function initVariationDropdowns(parentElement = document) {
    const dropdownElements = parentElement.querySelectorAll('.variation-dropdown')
    const variationDropdowns = []

    dropdownElements.forEach(dropdownElement => {
        if (dropdownElement.closest('.buy-overlay-source')) {
            return
        }

        if (variationDropdownInstances.has(dropdownElement)) {
            variationDropdowns.push(variationDropdownInstances.get(dropdownElement))
            return
        }

        const variationDropdown = new VariationDropdown(dropdownElement)
        variationDropdownInstances.set(dropdownElement, variationDropdown)
        variationDropdown.init()
        variationDropdowns.push(variationDropdown)
    })

    return variationDropdowns
}

export default function init() {
    initVariationDropdowns()
}
